<template>
  <section class="select-section">
    <el-dialog :visible.sync="dialogVisible" width="70%" center min-width="750px" append-to-body>
      <p slot="title">{{ title }}</p>
      <div class="search-row">
        <el-input
          placeholder="请输入内容"
          v-model="searchVal"
          class="input-with-select"
          @keyup.enter="getData"
          size="small"
        >
          <el-select style="width: 110px" v-model="searchKey" slot="prepend" placeholder="请选择">
            <el-option v-for="item in selectKey" :key="item.key" :value="item.key" :label="item.name"></el-option>
          </el-select>
        </el-input>
        <el-button
          type="primary"
          size="small"
          @click="
            currentPage = 1
            getData()
          "
          >搜索</el-button
        >
      </div>
      <el-table
        :data="tableData"
        class="table_list"
        top="10vh"
        style="width: 100%"
        border
        max-height="500"
        @row-click="rowClickHandle"
      >
        <el-table-column label="选择" width="50px" align="center">
          <template slot-scope="scope">
            <!-- <el-radio v-model="choiceDoctor" :label="scope.row">&nbsp;</el-radio> -->
            <div class="virtualBox"></div>
            <el-checkbox v-model="choiceDoctor" :label="scope.row">{{ '' }}</el-checkbox>
          </template>
        </el-table-column>
        <el-table-column label="医生姓名" min-width="25%">
          <template slot-scope="scope">
            <span>{{ scope.row.realName ? scope.row.realName : '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="手机号" min-width="25%">
          <template slot-scope="scope">
            <span>{{ scope.row.phone ? scope.row.phone : '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="医院" min-width="50%">
          <template slot-scope="scope">
            <span>{{ scope.row.hospitalName ? scope.row.hospitalName : '-' }}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wrap">
        <el-pagination
          class="el-pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[20, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
        >
        </el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitHandle">确 定</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script scoped>
import selectReq from '@/api/selectSource'
export default {
  name: 'selectDoctor',
  data() {
    return {
      title: '',
      blank: '',
      choiceDoctor: [],
      dialogVisible: false,
      selectKey: [
        {
          key: 'realName',
          name: '医生姓名'
        },
        {
          key: 'phone',
          name: '手机号'
        },
        {
          key: 'hospitalName',
          name: '所属医院'
        }
      ],
      searchKey: 'realName',
      searchVal: '',
      pageSize: 20,
      currentPage: 1,
      totalCount: 0,
      tableData: []
    }
  },
  props: {
    isSingle: {
      type: Boolean,
      default: () => true
    }
  },
  mounted() {},
  methods: {
    open(title) {
      this.choiceDoctor = []
      if (this.tableData.length == 0) {
        this.getData()
      }
      this.dialogVisible = true
      this.title = title
    },
    close() {
      this.dialogVisible = false
    },
    submitHandle() {
      // this.$emit('select-submit', this.choiceDoctor)

      if (this.isSingle) {
        this.$emit('select-submit', this.choiceDoctor[0] || {})
      } else {
        this.$emit('select-submit', this.choiceDoctor)
      }
      this.dialogVisible = false
    },
    rowClickHandle(row) {
      // this.choiceDoctor = row;

      if (this.isSingle) {
        this.choiceDoctor = [row]
      } else {
        var index = this.choiceDoctor.indexOf(row)
        if (index == -1) {
          this.choiceDoctor.push(row)
        } else {
          this.choiceDoctor.splice(index, 1)
        }
      }
    },
    getData() {
      let params = {
        page: this.currentPage,
        pageSize: this.pageSize,
        searchKey: this.searchKey,
        searchValue: this.searchVal
      }
      selectReq
        .docList(params)
        .then((res) => {
          if (res.Success) {
            this.tableData = res.Data.dataList
            this.totalCount = res.Data.totalCount
          } else {
            this.$message.error(res.Msg)
          }
        })
        .catch((res) => {
          this.$message.error('获取医生信息出错，请稍后再试！')
        })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    }
  }
}
</script>

<style type="text/less" lang="less" scoped>
.select-section {
  .el-dialog__wrapper {
    background-color: rgba(0, 0, 0, 0.1);
  }
  .pagination-wrap {
    margin-top: 10px;
  }
  .el-pagination {
    float: right;
  }
  .dialog-footer {
    margin-top: 40px;
  }
}
.search-row {
  margin-bottom: 10px;
  text-align: right;
  .input-with-select {
    width: 30%;
    min-width: 350px;
  }
  .search-select {
    width: 110px;
  }
}
.virtualBox {
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 9;
}
</style>
<style type="text/css">
.el-table .cell {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/selectSource/selectDoctor.vue